module.exports = __webpack_public_path__ + "img/logo-steam.4b5e44a7.svg";